import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { createModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/createModelConceptAttribute';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addDomainToAttributeModelData =
  ({ value, domain }: { value: string; domain: string }) =>
  (model: Model) => {
    const existingAttribute =
      model.modelData.attributesByIri[value] ||
      createModelConceptAttribute({ value });

    const existingDomain = existingAttribute.domains[domain] || {
      value: domain,
    };

    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: {
        ...existingAttribute,
        domains: {
          ...existingAttribute.domains,
          [domain]: {
            ...existingDomain,
          },
        },
      },
    });
  };
